import React from "react";
import { ButtonLink } from "components/flexible_testing/shared/button_link";
import { StatusCard } from "@hopper/status_card";

const FeedbackBanner = ({ onFeedbackClick }: { onFeedbackClick: () => void }) => (
  <StatusCard statusColor="warning" className="flex justify-start">
    Testers have provided{" "}
    <ButtonLink size="md" onClick={onFeedbackClick}>
      <span className="font-bold">feedback 💬</span>
    </ButtonLink>{" "}
    on the test cases in this test that can help improve future test case runs
  </StatusCard>
);

export default FeedbackBanner;
